import classNames from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form/immutable';

// components
import HolidayForm from '../_HolidayForm';
import { Button } from '../../shared/_form';
import { Link } from 'react-router';
import { currentManagerValidate } from '../../../actions/currentManagerActions';

// constants
const FORM_NAME = 'managerNew';

class OfficeClose extends React.Component {
  static propTypes = {
    _handleBack: PropTypes.func,
    currentUser: PropTypes.instanceOf(Immutable.Map),
    form: PropTypes.string,
    formValues: PropTypes.instanceOf(Immutable.Map),
    token: PropTypes.instanceOf(Immutable.Map),
    validateCurrentManager: PropTypes.func.isRequired
  }

  render() {
    const { currentUser, formValues, token, _handleGoBack } = this.props;

    const loading = currentUser.get('loading') || token.get('loading');

    return (
      <div className='manager-new__step3'>
        <p className='manager-new__step3__description'>
          Office is closed on:
        </p>
        <form className='manager-new__step3__form'
          onSubmit={ this._handleSubmit }>
          <HolidayForm form={ FORM_NAME }
            formValues={ formValues } />
          <div className='form__submit'>
            <Link className={ classNames('form__button form__button--purple manager-new__form__button', { 'form__button--disabled': loading }) }
              disabled={ loading } to={ _handleGoBack }>
              Back
            </Link>
            <Button className='form__button form__button--green manager-new__form__button'
              loading={ loading }>
              Next
            </Button>
          </div>
        </form>
      </div>
    );
  }

  // private

  _handleSubmit = this._handleSubmit.bind(this);

  _handleSubmit(e) {
    e.preventDefault();

    const { validateCurrentManager, formValues } = this.props;
    const form = formValues || Immutable.Map();

    if (HolidayForm.validate(this.props)) {
      validateCurrentManager(form.toJS());
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    formValues:  getFormValues(FORM_NAME)(state),
    token:       state.get('token')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    validateCurrentManager: (form) => dispatch(currentManagerValidate(form))
  };
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(
    reduxForm(
      {
        destroyOnUnmount: false,
        form: FORM_NAME
      }
    )(OfficeClose)
  )
);



// WEBPACK FOOTER //
// ./app/components/managers/signUp/_OfficeClose.jsx